import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DirectoryModel } from '@classes/wiki/directory-model.model';
import { SearchedFile } from '@classes/wiki/searched-file.model';
import { TextToFind } from '@classes/wiki/text-to-find.model';
import { environment } from '@environments/environment';
import { FileService } from '@services/wiki/file.service';
import { SearchedService } from '@services/wiki/searched.service';
import { UtilitiyService } from '@services/wiki/utility.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent extends SubscriptionBaseComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  private provider: string = null;

  searchResult: SearchedFile[];
  wordSearched: string;
  dataSource: MatTableDataSource<SearchedFile>;
  tableColumns: string[] = ['row'];
  isLoading = false;

  constructor(
    private router: Router,
    private searchedService: SearchedService,
    private utilityService: UtilitiyService,
    private fileService: FileService) {
    super();
  }


  ngOnInit(): void {
    this.initPage();
  }

  loadEditor(file: DirectoryModel): void {
    const strippedPath = file.path.substring(file.path.lastIndexOf('\\') + 1);
    const encryptedPath = this.utilityService.encryptString(strippedPath);
    this.router.navigate([`/smartwaste/Wiki/file/${encryptedPath}`]);
  }

  stripHtml(html: string): string {
    return this.utilityService.stripHtml(html);
  }

  private initPage(): void {
    this.dataSource = new MatTableDataSource<SearchedFile>();

    this.subscription.add(this.fileService.getProviderSub().subscribe(provider => {
      this.provider = provider;
      const word = sessionStorage.getItem(environment.wordSearched);
      if (word) {
        const ttf = JSON.parse(sessionStorage.getItem(environment.wordSearched));
        this.searchForWord(ttf);
        this.wordSearched = ttf.text;
      }
      this.subscription.add(this.searchedService.getTextToFindSub().subscribe(data => {
        this.searchForWord(data);
        this.wordSearched = data.text;
      }));
    }));
  }

  private searchForWord(ttf: TextToFind): void {
    this.isLoading = true;
    this.searchedService.findFiles(ttf, this.provider).subscribe(data => {
      this.isLoading = false;
      this.searchResult = data;
      this.dataSource.data = this.searchResult;
      this.dataSource.paginator = this.paginator;
    });
  }
}
